<mat-form-field
  [appearance]="!fromMobile || fromTransactionFilter || fromRules ? 'fill' : 'none'"
  [class]="
    !fromFloaterMenu
      ? fromTransactionFilter || fromRules
        ? 'automtic-form-desing-form-only w-[206px] max-[480px]:w-full'
        : 'app__table--form--field app__text--centered--field w-[98%]'
      : 'add__category--hidden--field'
  "
>
  <mat-select
    #expenseIncomeCategoryDropdown
    [(value)]="selectedValue"
    [placeholder]="selectedOptionsString"
    [disableOptionCentering]="true"
    [class]="fromTransactionFilter || fromRules ? 'transaction__select--form--field' : ''"
    [panelClass]="
      !fromFloaterMenu && !fromMobile
        ? fromTransactionFilter || fromRules
          ? 'income__expense--refund--category--dropdown income__expense--category--panel'
          : 'income__expense--refund--category--dropdown transaction__income--expense--panel'
        : 'income__expense--refund--category--dropdown categoryCustomizePositionOnFloater'
    "
    [disabled]="disableCategoryButton"
    (selectionChange)="fromTransactionFilter ? onCategorySelectionChange($event) : $event.stopPropagation(); $event.preventDefault()"
    [multiple]="fromTransactionFilter ? true : false"
    (openedChange)="openDropDownEvent($event, expenseIncomeCategoryDropdown)"
  >
    <mat-select-trigger>
      <div class="flex items-center">
        <span appTooltip [toolTipText]="selectedOptionsString" class="app__text--overflow w-[94%]"> {{ selectedOptionsString }} </span>
      </div>
    </mat-select-trigger>

    <div>
      <div class="mx-2 my-3 h-10">
        <div class="income__expense--category--header items-center justify-around h-full">
          <mat-form-field appearance="fill" class="w-full app__attributes-search-field">
            <input
              #myInput
              matInput
              type="text"
              class="w-[80%] pl-[10px]"
              [(ngModel)]="searchText"
              autocomplete="off"
              (input)="onSearchChange()"
              [placeholder]="'Search Categories'"
              (keydown.space)="$event.stopPropagation()"
            />
          </mat-form-field>
          <mat-icon class="text-[#C2C3C7]">search</mat-icon>
        </div>
      </div>

      @if(searchText && !selectedCategories?.length){
      <div>
        <p class="app__start--justified--content font-semibold px-4 text-[#C1C2C5]">No results found</p>
      </div>
      } @if(fromTransactionFilter && selectedCategories?.length){
      <div>
        <p class="app__start--justified--content px-4 hover:cursor-pointer" (click)="selectAllType()">All</p>
      </div>
      }

      <div class="income__expense--category--list max-h-[170px] min-h-[40px]" *ngIf="selectedCategories.length">
        @if(fromTransactionFilter && selectedCategories?.length){
        <mat-option class="hidden" [value]="{ level: 'type', value: 'All' }"></mat-option>
        } @for(item of selectedCategories; track item; let index = $index;){
        <mat-option [value]="{ level: 'type', value: item.type }">
          <div
            class="app__between--justified--content items-center"
            [class]="fromRules ? 'px-2' : ''"
            (click)="openCategoryListForSelectedType($event, index, item)"
          >
            <span appTooltip [toolTipText]="item.name" class="app__text--overflow w-[85%]"> {{ item.type | customTitlecase }} </span>
            @if(item.categories && item.categories.length){@if(item.isOpen){
            <span class="material-icons app__chevron--right--icon">chevron_left</span>
            }@else{
            <span class="material-icons app__chevron--right--icon">chevron_right</span>
            } }
          </div>
        </mat-option>

        <div class="ml-2" [class]="!item.isOpen ? 'hidden' : 'block'">
          <ng-container *ngIf="selectedCategories[index].categories.length; else showNotFound">
            <ng-container *ngFor="let currentData of selectedCategories[index].categories; let idx = index">
              <mat-option [value]="{ level: 'category', value: currentData.name, parent: item.type }">
                <div
                  class="app__between--justified--content items-center"
                  [class]="fromRules ? 'px-2' : ''"
                  (click)="openSubCategoryListForSelectedCategory($event, currentData, idx)"
                >
                  <span appTooltip [toolTipText]="currentData.name" class="app__text--overflow w-[85%]"> {{ currentData.name }} </span>
                  @if(currentData.subCategories && currentData.subCategories.length){ @if(currentData.isOpen){
                  <span class="material-icons app__chevron--right--icon">chevron_left</span>
                  }@else{
                  <span class="material-icons app__chevron--right--icon">chevron_right</span>
                  } }
                </div>
              </mat-option>

              <div class="ml-2" [class]="!currentData.isOpen ? 'hidden' : 'block'">
                <ng-container *ngIf="currentData.subCategories.length; else showNotFound">
                  <ng-container *ngFor="let childCurrentData of currentData.subCategories">
                    <mat-option [value]="{ level: 'subcategory', value: childCurrentData.name, parent: item.type, category: currentData.name }">
                      <span
                        appTooltip
                        [toolTipText]="childCurrentData.name"
                        [class]="fromRules ? 'px-2' : 'app__text--overflow w-[85%]'"
                        (click)="
                          onCategorySelectionChange(
                            { level: 'subcategory', value: childCurrentData.name, parent: item.type, category: currentData.name },
                            true
                          )
                        "
                      >
                        {{ childCurrentData.name }}
                      </span>
                    </mat-option>
                  </ng-container>
                </ng-container>
                <ng-template #showNotFound>
                  <mat-option disabled>
                    <span> No results found </span>
                  </mat-option>
                </ng-template>
              </div>
            </ng-container>
          </ng-container>
          <ng-template #showNotFound>
            <mat-option disabled>
              <span> No results found </span>
            </mat-option>
          </ng-template>
        </div>
        }
      </div>
      <!-- <ng-template #showNotFound>
        <mat-option disabled>
          <span> No results found </span>
        </mat-option>
      </ng-template> -->
      <ng-template #showTemplateLoader>
        <div class="max-h-[196px]" *ngFor="let count of loader; let i = index">
          <mat-option class="w-full p-0 m-0">
            <div class="ph-item border-none">
              <div class="ph-col-12 pt-5">
                <div class="ph-row">
                  <div class="ph-col-12 h-5"></div>
                </div>
              </div>
            </div>
          </mat-option>
        </div>
      </ng-template>
    </div>
  </mat-select>
</mat-form-field>
<span *ngIf="fromFloaterMenu" class="material-icons text-[#25508e] text-[30px] mt-[-28px] pl-5 absolute right-1 bottom-6 z-0">
  keyboard_arrow_down
</span>
